import React, { useState } from 'react';
import { userAPI } from '../../../../../services/api/userAPI';
import notificationService from '../../../../../services/notificationService';

const CreateUserModal = ({ isOpen, onClose, onSuccess }) => {
  const [form, setForm] = useState({ email: '', username: '', password: '', role: 'user' });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const errs = {};
    if (!form.email || !/\S+@\S+\.\S+/.test(form.email)) errs.email = 'Valid email is required';
    if (!form.password || form.password.length < 6) errs.password = 'Password must be at least 6 characters';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      await userAPI.createUser({
        email: form.email.trim(),
        username: form.username.trim() || form.email.split('@')[0],
        password: form.password,
        role: form.role
      });
      notificationService.success('User created successfully');
      setForm({ email: '', username: '', password: '', role: 'user' });
      onSuccess?.();
      onClose();
    } catch (err) {
      notificationService.error(err.response?.data?.details || err.message || 'Failed to create user');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 480 }}>
        <div className="modal-header">
          <h2>Create New User</h2>
          <button className="modal-close" onClick={onClose} aria-label="Close">&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div>
              <label className="detail-label">Email *</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                className="currency-select"
                style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: errors.email ? '1px solid #ef4444' : '1px solid #e2e8f0' }}
                placeholder="user@example.com"
              />
              {errors.email && <span style={{ color: '#ef4444', fontSize: 12 }}>{errors.email}</span>}
            </div>
            <div>
              <label className="detail-label">Username</label>
              <input
                type="text"
                name="username"
                value={form.username}
                onChange={handleChange}
                className="currency-select"
                style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e2e8f0' }}
                placeholder="Auto-generated from email if blank"
              />
            </div>
            <div>
              <label className="detail-label">Password *</label>
              <input
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                className="currency-select"
                style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: errors.password ? '1px solid #ef4444' : '1px solid #e2e8f0' }}
                placeholder="Min 6 characters"
              />
              {errors.password && <span style={{ color: '#ef4444', fontSize: 12 }}>{errors.password}</span>}
            </div>

          </div>
          <div className="modal-footer">
            <button type="button" className="modal-btn btn-cancel" onClick={onClose}>Cancel</button>
            <button
              type="submit"
              className="modal-btn"
              disabled={loading}
              style={{ background: 'linear-gradient(135deg, #3b82f6, #2563eb)', color: '#fff', border: 'none' }}
            >
              <i className={`fas ${loading ? 'fa-spinner fa-spin' : 'fa-plus'}`}></i>
              {loading ? 'Creating...' : 'Create User'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateUserModal;
